import { useState } from "react";
import { useTranslation } from "react-i18next";
import { showError } from "utils/index";
import { logoutUser } from "utils/logout";

interface UseLogout {
  logout: () => Promise<void>;
  isPending: boolean;
  isFailed: boolean;
}

const useLogout = (): UseLogout => {
  const { t } = useTranslation("common");
  const [isPending, setIsPending] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  const logout = async () => {
    setIsPending(true);
    setIsFailed(false);

    try {
      await logoutUser();
    } catch {
      setIsFailed(true);
      showError(t("logoutFailed"));
    } finally {
      setIsPending(false);
    }
  };

  return { logout, isPending, isFailed };
};

export default useLogout;
